seedWebApp.controller('ChangeIssuesModalController', ['$scope', '$uibModalInstance', 'ToastService', 'HelpdeskService', 'TranslationService', 'items',
    function ($scope, $uibModalInstance, ToastService, HelpdeskService, TranslationService, items) {

        $scope.items = items;
        $scope.translation = TranslationService.getActiveTranslation();

        //$scope.statusTypes = HelpdeskService.getStatusTypes();

        HelpdeskService.getStages().then(
            function (response) {
                //console.log('resp', response);
                //console.log(response.data);
                var stages = response.data;
                $scope.statusTypes = stages.map(function (stage) {
                return {
                    Key: stage.StageID,
                    Value: stage.StageName
                };
            });
            }
        );

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            $scope.loading = true;
                        
            var changes = {
                statusID: $scope.statusID,
                items: $scope.items,
            };
            if (!changes.statusID || changes.statusID == '') {
                ToastService.createToast('Erro', 'Falta selecionar o novo status', 2000, 'error');
                return;
            }

            var toastID = ToastService.createToast($scope.translation.SavingLoad, '', 4000, 'wait');
            HelpdeskService.saveChanges(changes).then(
                function () {
                    $scope.loading = false;
                    ToastService.updateToast(toastID, $scope.translation.ActionSuccessfullySaved, '', 4000, 'success');
                    $uibModalInstance.close();
                },
                function (error) {
                    $scope.loading = false;
                    console.log('save error: ');
                    //console.log(error.data);
                    var errorMsg = error.data.Message;
                    var errorExc = error.data.ExceptionMessage;
                    ToastService.updateToast(toastID, $scope.translation.ErrorSaving, errorExc, 4000, 'error');
                } );            
        };
    }
]);